import { render, staticRenderFns } from "./ProfileServices.vue?vue&type=template&id=2abc34b4&"
import script from "./ProfileServices.vue?vue&type=script&lang=js&"
export * from "./ProfileServices.vue?vue&type=script&lang=js&"
import style0 from "./ProfileServices.vue?vue&type=style&index=0&id=2abc34b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports